export const navigateToPath = (path: string) => {
  if (!path) {
    return null;
  }

  window.location.assign(`${path}`);
};
